import { defineField, defineType } from 'sanity'
import { strongEmLink } from '../../data/richText'

import AccessoriesSkus from '../../components/AccessoriesSkus'

export default defineType({
  name: 'tpmsStemsConfiguration',
  title: 'TPMS & Metal Valve Stems Configuration',
  type: 'document',
  fields: [
    defineField({
      name: 'name',
      title: 'Configuration Name',
      type: 'string',
      validation: (rule) => rule.required(),
    }),
    defineField({
      title: 'Info Message.',
      name: 'tpmsMessage',
      type: 'string',
    }),
    defineField({
      title: 'Info Modal',
      name: 'tpmsModal',
      type: 'reference',
      to: [{ type: 'modal' }],
    }),
    defineField({
      title: 'Metal Valve Stems message.',
      name: 'stemsMessage',
      type: 'string',
    }),
    defineField({
      title: 'Metal Valve Stems Modal',
      name: 'stemsModal',
      type: 'reference',
      to: [{ type: 'modal' }],
    }),
    // defineField({
    //   title: 'Required?',
    //   name: 'required',
    //   type: 'boolean',
    //   initialValue: false,
    // }),
    defineField({
      name: 'skus',
      title: 'Product SKUs',
      description: 'Comma separated skus can be used for searching',
      type: 'string',
      components: {
        input: AccessoriesSkus,
      },
    }),
  ],
  preview: {
    select: {
      title: 'name',
    },
    prepare({ title = 'New Configuration' }) {
      return {
        title,
        subtitle: 'TPMS & Metal Valve Stems Configuration',
      }
    },
  },
})
